var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgV2TournamentPrizeLaurelRight(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 91.0374,
    height: 153.547,
    viewBox: "0 0 91.0374 153.547",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 1000009826"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.3464 143.181C12.8329 141.427 19.2521 134.851 13.0578 126.67C11.31 128.388 9.75526 130.293 8.42175 132.352C6.01867 135.955 5.2341 142.541 5.24507 142.536C8.27697 140.319 10.6914 137.355 12.2568 133.93C12.2568 133.93 11.8892 137.124 7.65365 141.427C6.84426 142.263 5.94226 143.004 4.96527 143.634L5.31091 143.606C3.37947 144.075 1.56919 144.951 0 146.177C1.49509 145.907 3.01329 145.789 4.53184 145.824C12.5366 145.918 16.2674 148.212 16.2784 148.212C11.4553 146.704 6.36778 146.247 1.35516 146.872C1.31676 146.872 8.74546 151.754 14.7038 152.747C18.0478 153.343 21.4419 153.607 24.8373 153.536C21.8033 144.196 13.7766 142.172 7.3464 143.181Z",
    fill: "url(#paint0_linear_0_53)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M22.2429 136.981C27.7568 135.756 34.6862 129.809 29.4028 120.983C27.5428 122.541 25.8576 124.298 24.3771 126.224C21.7162 129.605 20.2842 136.153 20.2842 136.153C23.4783 134.205 26.1227 131.466 27.9653 128.199C27.9653 128.199 27.3014 131.36 22.7476 135.271C21.8818 136.031 20.9319 136.688 19.9166 137.229H20.2568C18.3246 137.515 16.4782 138.223 14.8471 139.303C16.3199 139.175 17.8018 139.201 19.2692 139.381C27.0052 140.247 30.4013 142.906 30.4068 142.906C25.8911 140.94 21.0002 139.998 16.0816 140.147C16.0487 140.147 22.6928 145.763 28.3823 147.319C31.5798 148.231 34.861 148.815 38.1756 149.062C36.195 139.403 28.5853 136.589 22.2429 136.981Z",
    fill: "url(#paint1_linear_0_53)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M35.9773 132.109C41.0633 130.112 46.3193 123.283 39.2253 115.444C37.7635 117.246 36.5169 119.214 35.511 121.308C33.673 125.004 33.8321 131.58 33.865 131.569C36.5168 129.194 38.4568 126.121 39.4667 122.698C39.4667 122.698 39.549 125.887 36.0432 130.355C35.3759 131.221 34.6037 131.999 33.7443 132.672L34.0845 132.628C32.2912 133.175 30.6481 134.133 29.2838 135.425C30.7112 135.09 32.1693 134.905 33.6346 134.873C41.4144 134.597 45.3482 136.71 45.3592 136.71C40.5773 135.427 35.5751 135.205 30.6993 136.059C30.6609 136.059 38.5779 140.566 44.4923 141.283C47.7778 141.725 51.099 141.836 54.4064 141.614C50.1105 132.457 42.0618 130.813 35.9773 132.109Z",
    fill: "url(#paint2_linear_0_53)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M48.1487 125.351C52.5927 122.643 56.0492 115.14 47.5397 108.548C46.5086 110.544 45.7308 112.662 45.2244 114.853C44.2588 118.748 45.9431 125.147 45.9541 125.142C47.9918 122.373 49.1696 119.06 49.3393 115.62C49.3393 115.62 50.1293 118.737 47.7811 123.63C47.3399 124.573 46.7732 125.451 46.0967 126.239L46.4314 126.14C44.8316 126.936 43.4535 128.119 42.4208 129.583C43.7367 129.04 45.1072 128.642 46.5082 128.396C53.9753 126.99 58.2328 128.496 58.2438 128.496C53.4271 127.915 48.5421 128.424 43.946 129.985C43.9076 129.985 52.675 133.251 58.5181 133.113C61.7301 133.084 64.93 132.715 68.0646 132.01C61.81 123.603 53.7175 123.189 48.1487 125.351Z",
    fill: "url(#paint3_linear_0_53)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M58.3013 116.949C61.9443 113.64 63.5738 105.663 54.0931 100.505C53.5182 102.629 53.2176 104.818 53.1988 107.02C53.0946 110.986 56.1396 117.021 56.1506 117.016C57.5009 113.908 57.902 110.467 57.3027 107.13C57.3027 107.13 58.7182 110.081 57.5661 115.256C57.3605 116.238 57.0149 117.186 56.5401 118.069C56.6443 118.025 56.7486 117.97 56.8528 117.915C55.498 118.951 54.4368 120.326 53.7749 121.903C54.9208 121.173 56.147 120.579 57.4289 120.133C64.2596 117.639 68.6213 118.478 68.6378 118.478C63.9839 118.607 59.4257 119.837 55.3331 122.069C55.3002 122.069 64.4681 123.989 69.9655 123.007C72.9779 122.521 75.9238 121.684 78.7439 120.513C70.9476 113.121 63.1349 113.948 58.3013 116.949Z",
    fill: "url(#paint4_linear_0_53)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M66.1022 107.075C68.8454 103.214 68.7357 95.0549 58.7284 91.4801C58.5942 93.6975 58.7491 95.923 59.1892 98.1C59.8915 102.028 64.0887 107.511 64.0996 107.506C64.7083 104.169 64.3679 100.727 63.1176 97.5759C63.1176 97.5759 65.0543 100.268 65.0652 105.564C65.082 106.555 64.9582 107.543 64.6977 108.499L64.9775 108.289C63.8984 109.541 63.1828 111.068 62.9091 112.702C63.8386 111.811 64.8742 111.038 65.9925 110.402C71.9233 106.893 76.1973 107.059 76.2138 107.059C71.883 107.896 67.8307 109.814 64.4288 112.636C64.4288 112.636 73.5309 113.155 78.4577 111.351C81.1558 110.422 83.7215 109.142 86.0894 107.544C77.2452 101.322 70.0415 103.379 66.1022 107.075Z",
    fill: "url(#paint5_linear_0_53)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M71.4077 96.1135C73.2127 91.8712 71.5394 83.7123 61.4113 81.8367C61.702 84.0571 62.2716 86.2314 63.1066 88.3076C64.5331 92.0754 69.6136 96.8416 69.6246 96.8306C69.5142 93.3998 68.5116 90.058 66.7167 87.1381C66.7167 87.1381 69.0595 89.4936 70.1348 94.7398C70.3534 95.7148 70.4401 96.715 70.3927 97.7132C70.4695 97.6305 70.5463 97.5422 70.6176 97.4484C69.8494 98.8937 69.4907 100.523 69.5807 102.16C70.2634 101.136 71.079 100.208 72.0057 99.4013C76.8612 94.9881 80.8664 94.464 80.8828 94.464C76.9993 96.0103 73.592 98.5626 71.0072 101.862C71.0072 101.862 79.6868 100.968 83.873 98.3973C86.191 97.0403 88.303 95.3552 90.144 93.3938C80.7018 88.5779 74.3429 91.8051 71.4077 96.1135Z",
    fill: "url(#paint6_linear_0_53)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M74.9785 90.1224C74.9785 90.1224 82.9064 87.8385 86.2477 84.6059C88.139 82.8371 89.7537 80.7913 91.0374 78.5377C81.469 75.2829 76.1306 79.5913 74.2268 84.3852C75.1156 79.8672 72.0926 71.9565 62.2224 71.8406C62.8764 73.9916 63.7981 76.0509 64.9656 77.9695C67.0011 81.4614 72.6851 85.3671 72.6906 85.3616C71.9317 81.9842 70.3733 78.8409 68.1478 76.1987C68.1478 76.1987 70.7594 78.146 72.7674 83.1936C73.1556 84.1294 73.4283 85.1094 73.5794 86.1119C73.6398 86.0126 73.6891 85.9078 73.744 85.8029C73.296 87.3892 73.2771 89.0669 73.6891 90.663C74.1249 89.5446 74.706 88.4891 75.4174 87.5241C79.0933 82.3386 82.7034 81.147 82.7144 81.147C79.3796 83.3845 76.707 86.4853 74.9785 90.1224Z",
    fill: "url(#paint7_linear_0_53)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M74.6463 72.199C74.6847 67.5376 70.5917 60.1289 61.2647 61.7838C62.2389 63.7937 63.457 65.6745 64.8913 67.3831C67.4041 70.4944 73.4228 73.4182 73.4228 73.4127C72.138 70.2181 70.1386 67.3639 67.5797 65.0717C67.5797 65.0717 70.3229 66.5501 73.11 71.2447C73.6397 72.1119 74.0687 73.0374 74.3884 74.0029C74.4213 73.8981 74.4542 73.7823 74.4817 73.672C74.3453 75.3362 74.6363 77.0077 75.3266 78.5265C75.5212 77.3451 75.866 76.1937 76.3525 75.1007C78.8324 69.3029 81.9542 67.4769 81.9597 67.4769C79.2386 70.3611 77.3216 73.9154 76.4019 77.7818C76.4019 77.7818 83.3368 74.174 85.8003 70.3345C87.2243 68.1987 88.3331 65.8667 89.0922 63.4112C79.7816 61.8114 75.5625 67.0742 74.6463 72.199Z",
    fill: "url(#paint8_linear_0_53)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M72.9631 59.9632C72.2499 55.2962 67.3175 48.5716 58.7696 51.9588C59.9922 53.7658 61.4334 55.4132 63.06 56.8629C65.9239 59.4943 72.0249 61.3479 72.0194 61.3424C70.3335 58.4253 68.0064 55.9346 65.2162 54.0605C65.2162 54.0605 68.0308 55.0259 71.3665 59.224C72.0048 60.0096 72.5566 60.8622 73.0125 61.7671C73.0125 61.6623 73.0125 61.5465 73.0399 61.4361C73.1796 63.1101 73.7342 64.7222 74.6529 66.1252C74.6308 64.9139 74.7542 63.7044 75.0205 62.5229C76.3483 56.2837 78.9379 53.8785 78.9379 53.8785C76.8854 57.311 75.7145 61.2031 75.5308 65.2039C75.5308 65.2039 81.33 60.388 82.9375 56.0686C83.9067 53.6419 84.5524 51.0969 84.8578 48.4999C76.0794 48.6102 72.9686 54.6674 72.9631 59.9632Z",
    fill: "url(#paint9_linear_0_53)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M69.4916 47.9927C68.131 43.4471 62.6225 37.6603 55.0073 42.6803C56.4142 44.2289 58.0128 45.5897 59.7641 46.7294C62.8585 48.8092 68.8332 49.5373 68.8223 49.5318C66.8423 46.9782 64.284 44.9374 61.3606 43.5795C61.3606 43.5795 64.1368 44.0043 67.8676 47.5735C68.5889 48.2456 69.233 48.9968 69.7879 49.8132C69.7879 49.7084 69.7879 49.6035 69.7604 49.4987C70.1309 51.1195 70.8985 52.6214 71.9934 53.8678C71.7801 52.6575 71.7047 51.4268 71.7685 50.1993C72.0428 43.7119 74.0948 40.8212 74.0948 40.8212C72.6985 44.6492 72.2064 48.7511 72.6573 52.8031C72.6573 52.8031 77.2605 46.9225 78.0834 42.2666C78.5966 39.6332 78.8083 36.9494 78.7144 34.2676C70.6931 36.0605 68.6796 42.7079 69.4916 47.9927Z",
    fill: "url(#paint10_linear_0_53)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M64.4837 36.7071C62.5908 32.4373 56.7367 27.7868 50.131 34.2743C51.6692 35.5254 53.369 36.5609 55.1841 37.3525C58.3992 38.8144 64.0941 38.3896 64.0777 38.3896C61.9169 36.2304 59.2335 34.6751 56.2923 33.8771C56.2923 33.8771 58.9697 33.7447 62.942 36.5802C63.7103 37.1177 64.4137 37.7434 65.0378 38.4448C65.0378 38.3565 64.9994 38.2627 64.9774 38.1745C65.528 39.6854 66.4534 41.0298 67.6658 42.0802C67.2905 40.9009 67.0458 39.6836 66.9361 38.4503C66.2887 31.9077 67.8359 28.5812 67.8249 28.5812C67.0231 32.6467 67.1261 36.8403 68.1267 40.861C68.1541 40.861 71.5502 34.0977 71.6929 29.2432C71.817 26.5081 71.6681 23.7674 71.2485 21.0622C64.0777 24.5486 63.0462 31.5657 64.4837 36.7071Z",
    fill: "url(#paint11_linear_0_53)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M44.4306 26.9253C46.0622 27.8473 47.8177 28.5273 49.6428 28.9444C52.8962 29.7388 58.2072 28.1831 58.1907 28.1831C55.8913 26.4686 53.1472 25.4608 50.2902 25.2814C50.2902 25.2814 52.8194 24.5918 56.8739 26.6109C57.6632 26.9931 58.4007 27.4751 59.0685 28.0452C59.0685 27.9679 59.0137 27.8907 58.9862 27.8135C59.6707 29.171 60.7101 30.3153 61.9928 31.1234C61.4832 30.0114 61.0986 28.8457 60.8461 27.648C59.4251 21.2543 60.5005 17.6079 60.4895 17.6079C60.1859 21.7609 60.7927 25.9302 62.2671 29.8215C62.2671 29.8215 64.5879 22.3742 64.1545 17.4645C63.9638 14.7261 63.5212 12.0114 62.8323 9.35518C56.5283 14.3807 56.3637 21.5467 58.3169 26.3737C56.029 22.5342 50.0104 19.1856 44.4306 26.9253Z",
    fill: "url(#paint12_linear_0_53)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M37.8865 21.3545C39.5908 21.9183 41.3706 22.2178 43.1645 22.2426C46.4016 22.353 51.279 19.7106 51.2571 19.7106C48.8227 18.472 46.0582 18.0487 43.3675 18.5024C43.3675 18.5024 45.7377 17.2888 49.8526 18.4252C50.6451 18.6326 51.403 18.956 52.102 19.3851C52.0746 19.3189 52.0417 19.2527 52.0142 19.192C52.7968 20.3813 53.9143 21.3089 55.2238 21.8565C54.6116 20.8445 54.1164 19.7654 53.7479 18.6403C51.685 12.5722 52.3544 8.7106 52.3379 8.7106C52.4419 12.8097 53.4659 16.8322 55.3335 20.4773C55.3335 20.4773 56.6722 12.5777 55.7779 7.78934C55.3308 5.13896 54.6552 2.53269 53.7589 0C48.245 6.40469 48.8211 13.5045 51.1913 17.8791C48.5523 14.5471 42.4678 12.5998 37.8865 21.3545Z",
    fill: "url(#paint13_linear_0_53)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M47.7933 13.4041C46.6507 10.6394 44.8786 8.18301 42.6195 6.23263C42.6195 6.23263 44.8745 7.13734 47.3818 11.2692C47.8717 12.0651 48.278 12.91 48.5943 13.7903C49.2856 9.37705 47.294 2.75721 37.4403 2.63033C37.4403 2.63033 38.4278 6.4919 40.6553 9.07915C42.8829 11.6664 47.7933 13.4041 47.7933 13.4041Z",
    fill: "url(#paint14_linear_0_53)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_53",
    x1: -0.754499,
    y1: 140.131,
    x2: 25.579,
    y2: 140.131,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#FFC752"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#FAD05E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#FFEC99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#FDE67E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB52B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_0_53",
    x1: 14.1385,
    y1: 135.046,
    x2: 38.8723,
    y2: 135.046,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#FFC752"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#FAD05E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#FFEC99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#FDE67E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB52B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_0_53",
    x1: 28.5206,
    y1: 128.606,
    x2: 55.1567,
    y2: 128.606,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#FFC752"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#FAD05E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#FFEC99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#FDE67E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB52B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_0_53",
    x1: 41.6418,
    y1: 120.853,
    x2: 68.8305,
    y2: 120.853,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#FFC752"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#FAD05E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#FFEC99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#FDE67E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB52B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_0_53",
    x1: 52.4201,
    y1: 111.914,
    x2: 79.5068,
    y2: 111.914,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#FFC752"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#FAD05E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#FFEC99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#FDE67E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB52B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_0_53",
    x1: 57.849,
    y1: 102.11,
    x2: 86.908,
    y2: 102.11,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#FFC752"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#FAD05E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#FFEC99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#FDE67E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB52B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_0_53",
    x1: 60.5385,
    y1: 92.0148,
    x2: 91.0021,
    y2: 92.0148,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#FFC752"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#FAD05E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#FFEC99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#FDE67E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB52B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_0_53",
    x1: 61.3471,
    y1: 81.2672,
    x2: 91.8979,
    y2: 81.2672,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#FFC752"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#FAD05E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#FFEC99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#FDE67E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB52B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_0_53",
    x1: 60.4194,
    y1: 70.0508,
    x2: 89.9232,
    y2: 70.0508,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#FFC752"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#FAD05E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#FFEC99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#FDE67E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB52B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_0_53",
    x1: 57.9771,
    y1: 57.327,
    x2: 85.6369,
    y2: 57.327,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#FFC752"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#FAD05E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#FFEC99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#FDE67E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB52B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_0_53",
    x1: 54.2865,
    y1: 44.0838,
    x2: 79.4447,
    y2: 44.0838,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#FFC752"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#FAD05E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#FFEC99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#FDE67E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB52B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_0_53",
    x1: 49.4747,
    y1: 31.5884,
    x2: 72.3805,
    y2: 31.5884,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#FFC752"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#FAD05E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#FFEC99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#FDE67E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB52B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_0_53",
    x1: 43.8298,
    y1: 20.2571,
    x2: 64.7991,
    y2: 20.2571,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#FFC752"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#FAD05E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#FFEC99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#FDE67E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB52B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_0_53",
    x1: 37.3337,
    y1: 11.1412,
    x2: 56.6293,
    y2: 11.1412,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#FFC752"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#FAD05E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#FFEC99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#FDE67E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB52B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_0_53",
    x1: 37.0977,
    y1: 8.21945,
    x2: 49.0553,
    y2: 8.21945,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#FFC752"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#FAD05E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#FFEC99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#FDE67E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB52B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgV2TournamentPrizeLaurelRight);
export default __webpack_public_path__ + "static/media/v2_tournament_prize_laurel_right.0c7f56edf4921c48bea01b993de89c94.svg";
export { ForwardRef as ReactComponent };